import { Form, Modal } from 'antd';
import styled from 'styled-components';
import Text from 'components/Text';
import RequestForm, { RequestFormValues } from './RequestForm';
import Button from 'components/Button';

interface Props {
  open: boolean;
  onClose: () => void;
  refetch?: () => void;
}

const AddRequestModal = ({ open, onClose, refetch }: Props) => {
  const [form] = Form.useForm<RequestFormValues>();

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <StyledModal open={open} onCancel={handleClose} footer={null} width={900} destroyOnClose closable={false}>
      <Content>
        <Text variant='H6' style={{ fontWeight: 'bold' }}>
          Add Support Ticket
        </Text>
        <RequestForm form={form} onClose={handleClose} refetch={refetch} />
      </Content>
      <Footer>
        <Button variant='DEFAULT' onClick={handleClose} style={{ flex: 1 }} size='middle' htmlType='button'>
          Close
        </Button>
        <Button variant='PRIMARY' style={{ flex: 1 }} size='middle' htmlType='submit' onClick={() => form.submit()}>
          OK
        </Button>
      </Footer>
    </StyledModal>
  );
};

export default AddRequestModal;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
  }
`;

const Content = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

const Footer = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  gap: 24px;
  background: #fff;
  box-shadow: 0 -4px 8px -4px rgba(0, 0, 0, 0.15);
  padding: 16px 24px 24px;
`;
